import { render } from "./ContactUs.vue?vue&type=template&id=7c3751b4"
import script from "./ContactUs.vue?vue&type=script&lang=js"
export * from "./ContactUs.vue?vue&type=script&lang=js"
script.render = render

export default script